import { Component, OnInit } from '@angular/core';
import { TotemService } from './totem.service';
import { NavigationEnd, Router } from '@angular/router';
// import { gremlins } from 'gremlins-ts';

import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { environment } from '../environments/environment';
import { StorageService } from './storage.service';
import { AnalyticsService } from './services/analytics.service';
import { QrCatalogService } from './services/qr-catalog.service';

declare var gtag: Function;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  
  tiemporeload;
  isOpen = false;
  public advertising: any;
  public showAdvertising = false;
  public actual: any;
  public index = 0;
  public next: any;
  public showTotem = false;

  public orientacionCorrecta = true;
  public modalShow = false;

  idleState = 'Not started.';
  timedOut = false;
  lastPing?: Date = null;

  constructor(private totemService: TotemService, private router: Router,
    private idle: Idle, private keepalive: Keepalive, private storageService: StorageService,
    private analytics: AnalyticsService, private qrCatalog: QrCatalogService) {

    // Nota: el auto-tracking SPA (page_view por NavigationEnd) ahora lo hace
    // AnalyticsService (services/analytics.service.ts). Aqui solo reseteamos
    // el idle timer en cada navegacion, para que despues de pintar una ruta
    // el totem NO se quede pegado esperando indefinidamente.
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        try { this.idle.watch(); } catch (e) { /* ignore */ }
      }
    });
// sets an idle timeout of 5 seconds, for testing purposes.
idle.setIdle(environment.timeoutIdle - 5);
// sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
idle.setTimeout(5);
// sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);

idle.onIdleEnd.subscribe(() => { 
  this.idleState = 'No longer idle.'
  console.log(this.idleState);
  this.reset();
});


idle.onIdleStart.subscribe(() => {
  this.idleState = 'You\'ve gone idle!'
  console.log(this.idleState);
});

idle.onTimeoutWarning.subscribe((countdown) => {
  this.idleState = 'You will time out in ' + countdown + ' seconds!'
  console.log(this.idleState);
});

idle.onTimeout.subscribe(() => {
  this.idleState = 'Timed out!';
  this.timedOut = true;
  console.log(this.idleState);

  //borrar session
  //localStorage.removeItem("nodos");
  this.storageService.setInicio("", "", "");
  this.storageService.setDestino("", "");

  this.reset();
  this.router.navigate(['/']);
});

// sets the ping interval to 15 seconds
keepalive.interval(15);

keepalive.onPing.subscribe(() => this.lastPing = new Date());

this.reset();

  }

  reset() {
    this.idle.watch();
    this.idleState = 'Started.';
    this.timedOut = false;
  }

  async ngOnInit() {
    // Precarga catalogo QR (tolerante a errores)
    this.qrCatalog.ensureLoaded().catch(() => { /* logeado en el servicio */ });

    // page_view inicial de Home para que no aparezca "(not set)" en GA4
    try { this.analytics.sendPageView('/home', 'Home'); } catch (err) {}

    // Deteccion QR en URL (camino legacy ?codigo=)
    this.detectarQR();

    if (window.innerWidth > window.innerHeight) {
      document.getElementById("myBtn").click();
    }

    window.addEventListener('orientationchange', () => {
        this.compararDimensiones();
    });
  }

  async detectarQR() {
    try {
      if (sessionStorage.getItem('qr_entry_sent') === '1') return;
      const urlParams = new URLSearchParams(window.location.search);
      const codigo = urlParams.get('codigo');
      if (!codigo) return;
      await this.qrCatalog.ensureLoaded();
      const qr = this.qrCatalog.findByCodigo(codigo);
      if (qr) {
        this.analytics.sendQrEntry(qr.nombre, qr.piso, codigo);
      } else {
        this.analytics.sendQrEntry('desconocido', '', codigo);
      }
      sessionStorage.setItem('qr_entry_sent', '1');
    } catch (err) {
      console.warn('Error detectando QR', err);
    }
  }

  public compararDimensiones(){
    console.log('comparar dim')
    if (window.innerHeight > window.innerWidth) {
      console.log('mal dim')
      document.getElementById("myBtn").click();
    } else {
      console.log('buen dim')
      document.getElementById("myBtnclose").click();
    }
  }

}
